import { render, staticRenderFns } from "./SyndicatedDeals.vue?vue&type=template&id=d0cb0b26&"
import script from "./SyndicatedDeals.vue?vue&type=script&lang=js&"
export * from "./SyndicatedDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports